import * as yup from 'yup';

import { DISCOUNT_CODE_FIELD } from '~/components/modal/discount-code-modal/discount-code-modal.schema';

export const discountCodeValidationSchema = yup.object({
  [DISCOUNT_CODE_FIELD]: yup.string().trim().required('Please provide promo code'),
});
